import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OrgAssessment from "@/pages/OrgAssessment";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OrgAssessment />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
